const routeImporters: Record<string, () => Promise<any>> = {
  '/': () => import('@/pages/HomePage'),
  '/about': () => import('@/pages/AboutPage'),
  '/pricing': () => import('@/pages/PricingPage'),
  '/products': () => import('@/pages/ProductsPage'),
  '/developers': () => import('@/pages/DevelopersPage'),
  '/developers/libraries': () => import('@/pages/LibrariesPage'),
  '/contact': () => import('@/pages/ContactPage'),
  '/support': () => import('@/pages/FaqPage'),
  '/blog': () => import('@/pages/BlogPage'),
  '/jobs': () => import('@/pages/JobsPage'),
  '/login': () => import('@/pages/auth/LoginPage'),
  '/signup': () => import('@/pages/auth/SignupPage'),
  '/products/stocks': () => import('@/pages/products/StocksPage'),
  '/products/credit': () => import('@/pages/products/CreditPage'),
  '/products/esg': () => import('@/pages/products/EsgPage'),
  '/products/etfs': () => import('@/pages/products/EtfsPage'),
  '/products/supply-chain': () => import('@/pages/products/SupplyChainPage'),
  '/products/crypto': () => import('@/pages/products/CryptoPage'),
  '/products/forex': () => import('@/pages/products/ForexPage'),
  '/products/futures': () => import('@/pages/products/FuturesPage'),
  '/products/economics': () => import('@/pages/products/EconomicsPage'),
  '/products/indices': () => import('@/pages/products/IndicesPage'),
  '/products/corporate-profiles': () => import('@/pages/products/CorporateProfilesPage'),
  '/products/sentiment': () => import('@/pages/products/SentimentPage'),
  '/products/webtraffic': () => import('@/pages/products/WebtrafficPage'),
  '/products/news': () => import('@/pages/products/NewsPage'),
  '/products/disclosures': () => import('@/pages/products/DisclosuresPage'),
  '/products/earnings': () => import('@/pages/products/EarningsPage'),
};

export function prefetchRoute(path: string) {
  const key = path.replace(/\/$/, '');
  const fn = routeImporters[key];
  if (fn) fn().catch(() => {});
}

export function prefetchRoutes(paths: string[]) {
  for (const path of paths) prefetchRoute(path);
}
